'use client'

import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { installWidgetSaveGuard } from '@/service/widget-save-guard'

export function WidgetSaveGuard() {
  const queryClient = useQueryClient()

  useEffect(() => {
    return installWidgetSaveGuard(window, queryClient)
  }, [queryClient])

  return null
}
